module.exports = __webpack_public_path__ + "static/media/Pencil.69322be3.svg";